<template slot-scope="props">
  <div>
    <form ref="form" role="form" @submit.stop.prevent="onSubmit">
      <!-- Ativo -->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <!-- Tipo -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo</span>
          <v-select
            :options="optionsTipo"
            label="tipoCampanha"
            name="tipo"
            data-vv-as="'tipo'"
            v-model="formCadastro.tipo"
            v-validate="'required'"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'tipo')
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'tipo',
              )
            "
          ></v-select>
        </div>
      </div>

      <!-- Cupom -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cupom</span>
          <vs-input
            size="large"
            class="w-full"
            name="cupom"
            id="input-cupom"
            data-vv-as="'cupom'"
            v-model="formCadastro.cupom"
            v-validate="'required|min:3'"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'cupom')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'cupom')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            autocomplete="off"
            @keyup="mascaraCupom($event)"
          />
        </div>
      </div>

      <!-- Periodo -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Período</span>
        </div>
        <!-- Data Inicio -->
        <div class="vx-col w-6/12">
          <vs-input
            size="large"
            class="w-full"
            name="dataInicio"
            data-vv-as="'data de início'"
            v-model="formCadastro.dataInicio"
            v-validate="'required|date_format:dd/MM/yyyy|before:dataFinal'"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'dataInicio',
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'dataInicio',
              )
            "
            danger-text="Preencha este Campo"
            val-icon-danger="clear"
            v-mask="'##/##/####'"
            icon-pack="feather"
            icon="icon-calendar"
            icon-no-border
            autocomplete="off"
          />
        </div>

        <!-- Data Final -->
        <div class="vx-col w-6/12">
          <vs-input
            size="large"
            class="w-full"
            name="dataFinal"
            data-vv-as="'data final'"
            ref="dataFinal"
            v-model="formCadastro.dataFinal"
            v-validate="'required|date_format:dd/MM/yyyy'"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'dataFinal',
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'dataFinal',
              )
            "
            danger-text="Preencha este Campo"
            val-icon-danger="clear"
            v-mask="'##/##/####'"
            icon-pack="feather"
            icon="icon-calendar"
            icon-no-border
            autocomplete="off"
          />
        </div>
      </div>

      <!-- Tipo aplicacao desconto -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Quando existir outro desconto</span>
          <v-select
            :options="optionsConvivenciaDesconto"
            label="tipoConvivencia"
            name="tipoConvivenciaDesconto"
            data-vv-as="'quando existir outro desconto'"
            v-model="formCadastro.convivenciaDesconto"
            v-validate="'required'"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'tipoConvivenciaDesconto',
              )
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'tipoConvivenciaDesconto',
              )
            "
          ></v-select>
        </div>
      </div>

      <!-- Quantidade de Utilizacao -->
      <div class="vx-row mb-6" v-show="checkCampanha()">
        <div class="vx-col w-full">
          <span>Limite de Utilização</span>
          <vs-input
            size="large"
            class="w-full"
            name="quantidadeUtilizacao"
            data-vv-as="'limite de utilização'"
            v-model="formCadastro.quantidadeUtilizacao"
            v-validate="'required'"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'quantidadeUtilizacao',
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'quantidadeUtilizacao',
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            autocomplete="off"
            type="number"
          />
        </div>
      </div>

      <!-- Produtos -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Produtos</span>
          <v-select
            :options="listProdutos"
            label="nomeProduto"
            name="produtos"
            v-model="produtoSelecionado"
            :class="validateClassProdutos"
          ></v-select>

          <!-- Lista de Produtos  -->
          <div class="mt-6">
            <vs-list-item
              v-for="item in listDescontoProduto"
              :key="item.idProduto"
              :title="item.nomeProduto"
              :subtitle="`(${item.prefixo}) ${item.valorMasked}`"
            >
              <template slot="avatar">
                <vs-button
                  @click="removeItemlistDescontoProduto($event, item)"
                  class="mr-2"
                  color="primary"
                  type="border"
                  icon="clear"
                ></vs-button>
              </template>
            </vs-list-item>
          </div>
        </div>
      </div>

      <!-- Mensagem de Validação -->
      <vs-alert
        v-if="$validator.errors.all().length > 0 || !validateProdutos()"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>

          <li class="mb-2" v-if="!validateProdutos()">
            O campo 'produtos' é obrigatório.
          </li>
        </ul>
      </vs-alert>

      <!-- Botões -->
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <!-- Botão Cancelar -->
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="close"
          >
            Cancelar
          </vs-button>

          <!-- Botão Cadastrar -->
          <BotaoSubmit
            name="SalvarCampanh"
            variant="success"
            :edit="editMode"
            :aguarde="aguardeCadastro"
          />
        </div>
      </div>
    </form>

    <!-- Popup - Form Desconto Produto -->
    <form-campanha-desconto-produto
      title="Desconto do Produto"
      :active="showPopupDescontoProuto"
      :produtoSelecionado="produtoSelecionado"
      :listDescontoProduto.sync="listDescontoProduto"
      @close="(showPopupDescontoProuto = false), (produtoSelecionado = null)"
    />
  </div>
</template>

<script>
//#region Import's

import BotaoSubmit from '../../components/BotaoSubmit.vue';
import FormCampanhaDescontoProduto from './FormCampanhaDescontoProduto.vue';
import dateConversion from './../../utils/dateConversion';
import locale from './../../locale';
import notify from './../../utils/notify';
import processingListProdutos from './FormCampanhaAux';
import service from './../../services';
import utilsList from './../../utils/list';
import vSelect from 'vue-select';

//#endregion

export default {
  components: { BotaoSubmit, 'v-select': vSelect, FormCampanhaDescontoProduto },
  props: ['idCampanha'],
  data() {
    const defaultForm = Object.freeze({
      idCampanha: null,
      idEmpresa: null,
      cupom: null,
      status: true,
      tipo: null,
      dataInicio: null,
      dataFinal: null,
      convivenciaDesconto: null,
      quantidadeUtilizacao: 1,
    });
    const TIPO_CUPOM = 1;
    const TIPO_CAMPANHA = 2;

    return {
      utilsList,
      aguardeCadastro: false,
      defaultForm,
      formCadastro: Object.assign({}, defaultForm),
      optionsTipo: [
        { idTipoCampanha: TIPO_CUPOM, tipoCampanha: 'Cupom' },
        { idTipoCampanha: TIPO_CAMPANHA, tipoCampanha: 'Campanha' },
      ],
      optionsConvivenciaDesconto: [
        { idConvivenciaDesconto: 1, tipoConvivencia: 'Sobrepor' },
        { idConvivenciaDesconto: 2, tipoConvivencia: 'Somar' },
      ],
      showPopupDescontoProuto: false,
      listProdutos: [],
      produtoSelecionado: [],
      listDescontoProduto: [],
      TIPO_CAMPANHA,
      validateClassProdutos: '',
      editMode: false,
    };
  },
  methods: {
    resetForm() {
      this.formCadastro = Object.assign({}, this.defaultForm);
      this.$validator.reset();

      // POG
      setTimeout(() => {
        this.listDescontoProduto = [];
        this.validateClassProdutos = '';
      }, 0);
    },
    close(event) {
      event.preventDefault();
      this.resetForm();
      this.$emit('update:idCampanha', null);
      this.$emit('closeSideBar');
    },
    async onSubmit(event) {
      event.preventDefault();

      try {
        const validate = await this.validate();
        if (!validate) {
          return;
        }

        this.aguardeCadastro = true;

        const data = this.sanitizeDataForm();
        const action = data.idCampanha ? 'update' : 'create';

        await service.post('Campanha', action, data);

        notify.notifySuccess(this.$vs, 'Campanha cadastrada com sucesso!');
        this.close(event);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.aguardeCadastro = false;
      }
    },
    async validate() {
      const validateForm = await this.$validator.validateAll();
      const validateProdutos = this.validateProdutos();

      this.toggleValidateClassProdutos(validateProdutos);

      return validateProdutos && validateForm;
    },
    validateProdutos() {
      if (this.veeFields['tipo']) {
        if (this.veeFields['tipo'].validated) {
          return this.listDescontoProduto.length > 0;
        }
      }
      return true;
    },
    toggleValidateClassProdutos(value) {
      this.validateClassProdutos = value ? '' : 'has-error';
    },
    async getListProdutos() {
      try {
        this.$vs.loading();
        const result = await service.getAll(
          'Produto',
          {},
          `list/idEmpresa=${this.idEmprsa}`,
        );

        this.listProdutos = result.data.filter((x) => x.deletedAt == null);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    removeItemlistDescontoProduto(event, value) {
      event.preventDefault();
      const index = this.listDescontoProduto.indexOf(value);
      if (index >= 0) {
        this.listDescontoProduto.splice(index, 1);
      }
    },
    mascaraCupom(event) {
      const input = event.target;
      input.value = input.value.replace(new RegExp(' ', 'g'), '-');
    },
    checkCampanha() {
      if (this.formCadastro.tipo) {
        return this.formCadastro.tipo.idTipoCampanha == this.TIPO_CAMPANHA;
      }
      return false;
    },
    sanitizeDataForm() {
      const result = Object.assign({}, this.formCadastro);

      // Regra: Cupom com eletras maiusculas
      result.cupom = result.cupom.toUpperCase();

      if (this.formCadastro.tipo) {
        result['idTipoCampanha'] = this.formCadastro.tipo.idTipoCampanha;
        delete result.tipo;
      }

      if (this.formCadastro.convivenciaDesconto) {
        result['idConvivenciaDesconto'] =
          this.formCadastro.convivenciaDesconto.idConvivenciaDesconto;
        delete result.convivenciaDesconto;
      }

      result.dataInicio = dateConversion.convertDateToISO(result.dataInicio);
      result.dataFinal = dateConversion.convertDateToISO(result.dataFinal);

      const campanhaProdutos = (result['Campanha_Produtos'] = []);

      this.listDescontoProduto.forEach((element) => {
        campanhaProdutos.push({
          idProduto: element.idProduto,
          idTipoDesconto: element.idTipoDesconto,
          valorDesconto: element.valor,
        });
      });

      return result;
    },
    async loadDataCampanha(value) {
      try {
        this.$vs.loading();

        const action = `get/${value}`;
        const getAll = await service.getAll('Campanha', {}, action);

        const result = getAll.data;
        this.processingReceivedData(result);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    processingReceivedData(value) {
      // Tipo
      value['tipo'] = value.TipoCampanha;
      delete value.TipoCampanha;

      // Tipo Desconto
      value['convivenciaDesconto'] = value.ConvivenciaDesconto;
      delete value.ConvivenciaDesconto;

      // Período
      value.dataInicio = dateConversion.converteISOToDate(value.dataInicio);
      value.dataFinal = dateConversion.converteISOToDate(value.dataFinal);

      // Lista de Desconto_Produtos
      const arrayDescontoProdutos = processingListProdutos(
        value.Campanha_Produtos,
      );

      this.formCadastro = Object.assign({}, value);
      this.listDescontoProduto = arrayDescontoProdutos;
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
    this.getListProdutos();
  },
  watch: {
    produtoSelecionado(value) {
      if (value) {
        this.showPopupDescontoProuto = true;
      }
    },
    'formCadastro.tipo'() {
      if (!this.checkCampanha()) {
        this.formCadastro.quantidadeUtilizacao = 1;
      }
    },
    listDescontoProduto() {
      // Realiza apenas quando o formulário já passou por validação
      if (this.veeFields['tipo'].validated) {
        this.toggleValidateClassProdutos(this.listDescontoProduto.length > 0);
      }
    },
    idCampanha(value) {
      if (value) {
        this.loadDataCampanha(value);
      }
      this.editMode = value ? true : false;
    },
  },
};
</script>

<style>
#input-cupom {
  text-transform: uppercase;
}
</style>
